import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css'; // Import Tailwind CSS directives
import App from './App'; // Import main application component

// Create the root element for React rendering
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the App component
   root.render(
        <BrowserRouter>
          <App />
        </BrowserRouter>
    );
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: [https://bit.ly/CRA-vitals](https://bit.ly/CRA-vitals)
// reportWebVitals(); // Optional: Performance monitoring
